import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Title } from 'react-head';
import { fetchUser } from '../../actions/userActions';
import { fetchToggles } from '../../actions/togglesActions';
import QueryActionHandler from '../QueryActionHandler';
import './styles.css';
import getRoutes from '../../routes';

function needsFetch({ loaded, loading }) {
    return !(loaded || loading);
}

class App extends Component {
    static propTypes = {
        user: PropTypes.object,
    };

    static fetchData({ getState, dispatch }) {
        return Promise.all([
            needsFetch(getState().user) && dispatch(fetchUser()),
            needsFetch(getState().toggles) && dispatch(fetchToggles()),
        ]);
    }

    render() {
        return (
            <div>
                <div className="employer-app">
                    <Title>Bedriftsprofiler - FINN jobb</Title>
                    <Switch>
                        {getRoutes().map((route) => (
                            <Route {...route} key={route.path} />
                        ))}
                    </Switch>
                </div>
                <QueryActionHandler />
            </div>
        );
    }
}

const ConnectedApp = connect((state) => ({
    user: state.user,
}))(App);

export { ConnectedApp as App };
export default withRouter(ConnectedApp);
